import React from 'react';
import styled from 'styled-components';
import times from 'lodash/times';
import LoadingMask from '../../../CommonComponents/LoadingMask';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledLoadingMask = styled(LoadingMask).attrs({
  isDark: true,
})`
  & + & {
    margin-top: 16px;
  }
`;

const LoadingView = ({ hasOrionRiskAlyseIntegration }) => {
  return (
    <Wrapper>
      {hasOrionRiskAlyseIntegration && (
        <StyledLoadingMask height="270px" style={{ marginBottom: 48 }} />
      )}
      <StyledLoadingMask width="256px" height="48px" style={{ marginBottom: 48 }} />
      {times(4).map(key => (
        <StyledLoadingMask key={key} height="48px" width="50%" />
      ))}
    </Wrapper>
  );
};

export default LoadingView;
